import axiosIns from '@/libs/axios'

const ROOT_URL = '/Clients/data/customers'
export default {
  namespaced: true,
  state: {
    dataList: [],
    dataCounts: 0,
    dataItem: {
      id: null,
      company: null,
      name: null,
      phone_region_code: 90,
      phone_region_iso2: 'TR',
      phone: null,
      phone2_region_code: 90,
      phone2_region_iso2: 'TR',
      phone2: null,
      fax: null,
      fax_region_code: 90,
      fax_region_iso2: 'TR',
      email: null,
      notes: null,
      tax_office: null,
      tax_number: null,
      address: null,
      id_sectors: null,
      id_meets: null,
      id_countries: null,
      id_cities: null,
      related_persons: [
        {
          id: null,
          name: null,
          email: null,
          phone_region_code: 90,
          phone_region_iso2: 'TR',
          phone: null,
          id_related_person_types: null,
        },
      ],
      machine_parkour: [],
      activities: [],
      sectors: [],
    },
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
    phoneControl: {
      status: false,
      id: null,
    },
    filterData: {
      id_sectors: [],
      id_activities: [],
      id_parkour_types: [],
      id_meets: null,
      id_countries: null,
      id_cities: null,
    },
    search: {
      keyword: null,
    },
    detailForm: false,
    detailSearch: false,
  },
  getters: {
    dataList(state) {
      return state.dataList
    },
    dataCounts(state) {
      return state.dataCounts
    },
    dataItem(state) {
      return state.dataItem
    },
    phoneControl(state) {
      return state.phoneControl
    },
    detailForm(state) {
      return state.detailForm
    },
    detailSearch(state) {
      return state.detailSearch
    },
    filterData(state) {
      return state.filterData
    },
    search(state) {
      return state.search
    },
  },
  mutations: {
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    SET_PHONE_CONTROL(state, data) {
      state.phoneControl = data
    },
    SET_DETAIL_FORM(state, data) {
      state.detailForm = data
    },
    SET_DETAIL_SEARCH(state, data) {
      state.detailSearch = data
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = {
        id: null,
        company: null,
        name: null,
        phone_region_code: 90,
        phone_region_iso2: 'TR',
        phone: null,
        phone2_region_code: 90,
        phone2_region_iso2: 'TR',
        phone2: null,
        fax: null,
        fax_region_code: 90,
        fax_region_iso2: 'TR',
        email: null,
        notes: null,
        tax_office: null,
        tax_number: null,
        address: null,
        id_sectors: null,
        id_meets: null,
        id_countries: null,
        id_cities: null,
        related_persons: [
          {
            id: null,
            name: null,
            email: null,
            phone_region_code: 90,
            phone_region_iso2: 'TR',
            phone: null,
            id_related_person_types: null,
          },
        ],
        machine_parkour: [],
        activities: [],
        sectors: [],
      }
    },
  },
  actions: {
    getDataList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.count)
        })
        .catch(error => console.error(error))
    },
    getDataItem({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'customers.id': id,
        },
        array: false,
      })
      return axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_ITEM', response.data.data)
          return response.data.data
        })
        .catch(error => console.error(error))
    },
    /* Custom */
    getPhoneControl({ commit }, params) {
      axiosIns
        .post(`${ROOT_URL}/phoneControl`, params)
        .then(response => {
          commit('SET_PHONE_CONTROL', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
